import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { contokVisible, itectorVisible } from "helpers/Mobile";
import { AuthService } from "services/AuthService";

import MainButton from "../../atoms/RoundedButton";
import Tooltip from "../../atoms/Tooltip";
import Icon from "components/MainApp/atoms/Icon/icon";
import i18n from "i18n";

import styles from "./MainApp.layouts.HeaderMobile.module.scss";
import useWindowSize from "hooks/useWindowSize";

const Header = ({
  goBackFunc,
  title,
  options,
  optionsIcons,
  buttonLabel,
  buttonHandler,
  buttonState,
  content,
  closeFunc,
}) => {
  const { isMobile } = useWindowSize();
  const [node, _] = useState(AuthService.currentNodeValue());
  const history = useHistory();
  return (
    <div className={styles["header-container"]}>
      <div className={styles["left-container"]}>
        {goBackFunc && (
          <i
            className={`${styles["icon-go-back-desktop"]} icon-chevron-izquierda`}
            onClick={goBackFunc}
            data-automation-id="go-back-header"
          ></i>
        )}
        {goBackFunc && (
          <i
            className={`${styles["icon-go-back-mobile"]} icon-back`}
            onClick={goBackFunc}
            cdata-automation-id="go-back-header"
          ></i>
        )}
        {closeFunc && (
          <i
            className={`${styles["icon-go-back-desktop"]} icon-cruz`}
            onClick={closeFunc}
            data-automation-id="go-back-header"
          ></i>
        )}
        {closeFunc && (
          <i
            className={`${styles["icon-go-back-mobile"]} icon-cruz`}
            onClick={closeFunc}
            cdata-automation-id="go-back-header"
          ></i>
        )}
        <div className={goBackFunc ? styles["title-go-back"] : styles["title"]}>{title}</div>
      </div>
      <div className={styles["right-container"]}>
        {content && content}
        {buttonLabel &&
          !isMobile && (
            <div className={styles["header-button"]}>
              <MainButton
                legend={buttonLabel}
                state={buttonState}
                handleClick={buttonHandler}
              ></MainButton>
            </div>
          )}
        {optionsIcons?.map((option) => {
          return (
            <div
              className={styles["header-item"]}
              key={option.name}
              onClick={option.handler}
              data-automation-id="menu-option"
            >
              <Tooltip
                content={<Icon
                  className={`icon ${option.icon}`}
                  name={option.icon}
                  fill={isMobile ? "#fff" : "#3C7AF5"}
                  width={23}
                  height={27}
                />}
                text={option.tooltip}
              ></Tooltip>
            </div>
          );
        })}
        {options.map((option) => {
          if(option.name?.match(/(shelving)/) && (!isMobile ||  !itectorVisible)) return;
          if(option.name?.match(/(contok)/) && (!isMobile ||  !contokVisible)) return;
          return (
            <div
              className={styles["header-item"]}
              key={option.name}
              onClick={option.handler}
              data-automation-id="menu-option"
            >
              {option?.count > 0 && <span>{option.count}</span>}
              <Tooltip
                content={ option.icon ?
                <i className={`icon ${option.icon}`}></i>
                :
                <img src={option.ic}></img>
              }
                text={option.tooltip}
              ></Tooltip>
            </div>
          );
        })}
        <div
          className={`${styles["header-item"]} ${styles["sucursal"]}`}
          key={"sucursal"}
          onClick={() => {
            history.push("/admin/active-node");
          }}
          data-automation-id="menu-option"
        >
          <Tooltip
            content={
              <div className={styles["icon"]}>
                <Icon
                  className={`${styles["icon"]} ${styles["sucursal"]}`}
                  name={isMobile ? "sucursal" : "sucursal-azul"}
                  fill={isMobile ? "#fff" : "#3C7AF5"}
                  width={24}
                  height={22}
                />
                {!isMobile && (
                  <p>
                    {i18n.t("branch.office")}{" "}
                    {node ? ` ${node.name}` : ""}
                  </p>
                )}
              </div>
            }
            text={i18n.t("branch.office")}
          ></Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Header;